import { render, staticRenderFns } from "./TheVideo.vue?vue&type=template&id=1502f54c&scoped=true"
import script from "./TheVideo.vue?vue&type=script&lang=js"
export * from "./TheVideo.vue?vue&type=script&lang=js"
import style0 from "./TheVideo.vue?vue&type=style&index=0&id=1502f54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1502f54c",
  null
  
)

export default component.exports